'use client'

import 'dayjs/locale/en'
import 'dayjs/locale/vi'
import 'dayjs/locale/fr'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/ar-sa'
import 'dayjs/locale/it'
import dayjs from 'dayjs'
import { useTranslate } from './use-locales'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LocalizationProvider as Provider } from '@mui/x-date-pickers/LocalizationProvider'
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { PropsWithChildren } from 'react'

// --------------------------------------------------------------------------------------------- //

export function LocalizationProvider({ children }: PropsWithChildren) {
  const { currentLang } = useTranslate()

  dayjs.locale(currentLang?.adapterLocale)

  return (
    <Provider dateAdapter={AdapterDayjs} adapterLocale={currentLang?.adapterLocale}>
      {children}
    </Provider>
  )
}
